export const FIGHT_SIZES = {
  SoloAttacker: CreateFightSize('SoloAttacker', 'Solo Attacker', 'Only one player damaged the victim.'),
  DuoAttackers: CreateFightSize('DuoAttackers', 'Two Attackers', 'Two players damaged the victim.'),
  TrioAttackers: CreateFightSize('TrioAttackers', 'Three Attackers', 'Three players damaged the victim.'),
  FourToSevenFighters: CreateFightSize('FourToSevenFighters', '4-7 Fighters', 'Battles with 4-7 combatants.'),
  EightToFifteenFighters: CreateFightSize('EightToFifteenFighters', '8-15 Fighters', 'Battles with for 8-15 combatants.'),
  SixteenToTwentyFiveFighters: CreateFightSize('SixteenToTwentyFiveFighters', '16-25 Fighters', 'Battles with for 16-25 combatants'),
  TwentySixToFiftyFighters: CreateFightSize('TwentySixToFiftyFighters', '26-50 Fighters', 'Battles with for 26-50 combatants'),
  FiftyPlusFighters: CreateFightSize('FiftyPlusFighters', '50+ Fighters', 'Battles with 50+ combatants'),
};

export interface FightSize {
  name: string;
  displayName: string;
  description: string;
}

export function CreateFightSize(name: string, displayName: string, description: string): FightSize {
  return { name, displayName, description };
}

export function GetAllFightSizes(): FightSize[] {
  return Object.values(FIGHT_SIZES);
}
